import React, { useLayoutEffect, useEffect, useState } from "react"
import ExpressForm from "./ExpressForm";
import backgroundImage from './footerImage.svg'
// import logo from './v2.png'
// import logo from './clearscore.svg'
import '../styles/expressFormDynamic.css'
// import { useMediaQuery } from 'react-responsive'

import TrustpilotDesktop from "./trustpilotWidgetDesktop";
import TrustpilotMobile from "./trustpilotWidgetMobile";
import SuccessBlock from "./successBlock";


function subText() {

  if (process.env.REACT_APP_PARTNER_USP_SUBTEXT === '') {
    return null
  } else {
    return (
      <h3 className="text-md font-semibold px-6 pb-6" style={{ color: process.env.REACT_APP_PARTNER_USP_SUBTEXT_COLOUR }}>{process.env.REACT_APP_PARTNER_USP_SUBTEXT}</h3>
    )
  }
}



// ** Media Queries to decide how to show TP Widget

// const useDesktopMediaQuery = () =>
//   useMediaQuery({ query: "(min-width: 1280px)" })

// const useTabletAndBelowMediaQuery = () =>
//   useMediaQuery({ query: "(max-width: 1279px)" })

// interface MediaProps {
//   children: any;
// }

// const Desktop = ({ children }: MediaProps): JSX.Element | null => {
//   const isDesktop = useDesktopMediaQuery()
//   if (isDesktop) {

//     return children
//   }
//   return null

// }

// const TabletAndBelow = ({ children }: MediaProps): JSX.Element | null => {
//   const isTabletAndBelow = useTabletAndBelowMediaQuery()
//   if (isTabletAndBelow) {

//     return children
//   }
//   return null
// }



// class Layout extends React.Component {
const Layout = () => {


  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const [renderMobileTP, setRenderMobileTP] = useState<boolean>(false);
  const [vrgId, setVrgId] = useState<string>('');
  const onsubmitHook = (data?:any)=>{
    setVrgId(data.vrgId)
  }

  useLayoutEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth < 450) {
        setRenderMobileTP(true);
      } else {
        setRenderMobileTP(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (windowWidth < 450) {
      setRenderMobileTP(true);
    } else {
      setRenderMobileTP(false);
    }
  }, [windowWidth]);

  const scrollToForm = () => {
    const form = document.getElementById('formStart');
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.error('Could not find form element');
    }
  };

  const getBannerClass = () => {
    const isNotSecured = process.env.REACT_APP_CC_IS_SECURED_FINANCE === 'false'
    const isAssetFinance = process.env.REACT_APP_CC_IS_ASSET_FINANCE === 'true'
    if(isNotSecured && isAssetFinance){
      return 'businessBanner'
    }
    else if(isNotSecured && !isAssetFinance){
      return 'lg:moneyAndStars'
    }
    else if(!isNotSecured && isAssetFinance){
      return 'lg:trucksAndStars'
    }
    else{
      return 'lg:carsAndStars'
    }
  }
  return (
    <>
      <div className="md:h-screen w-full pb-6" style={{ backgroundColor: '#FAFAFA', backgroundImage: `url(${backgroundImage})`, backgroundPosition: 'center bottom', backgroundRepeat: 'no-repeat', backgroundAttachment: 'fixed', height: 'auto', minHeight: '100vh' }}>
        <div className="md:flex w-full gap-6 mx-auto md:px-12" style={{ maxWidth: '1440px' }}>
          <a className="mx-6 mt-6" style={{display:"inline-block"}} href={process.env.REACT_APP_PARTNER_URL?.toString() ?? ''} target="_blank" rel="noopener noreferrer">
            <img src={`https://carclarity-assets-public.s3.ap-southeast-2.amazonaws.com/partnerLogos/${process.env.REACT_APP_PARTNER_CC_DOMAIN_KEY}/logo`} alt={`${process.env.REACT_APP_PARTNER_NAME} logo`} className=" w-36" />
          </a>
        </div>
        <div className="md:flex w-full gap-6 justify-center mx-auto md:px-12" style={{ maxWidth: '1440px' }}>
          <div className="flex flex-auto flex-col xs:w-full lg:w-2/3 justify-start items-start md:mr-3 mx-6" >
            <div className="flex flex-col items-start justify-start bg-partnerBrandPrimary mx-auto  mt-4 w-full rounded-lg shadow-sm">
              <h1 className="text-xl px-6 pt-6 pb-6" style={{ fontWeight: '500', color: process.env.REACT_APP_PARTNER_USP_TEXT_COLOUR }} >{`${process.env.REACT_APP_PARTNER_USP_TEXT}`}</h1>
              {subText()}
              {!vrgId ? <div className="flex flex-row w-full items-start justify-start px-6 pb-6 mx-auto md:hidden ">
                <button onClick={scrollToForm} data-dd-action-name="Click Apply Now on Mobile" className="text-partnerBrandPrimary bg-white font-semibold font-avenir text-sm px-8 py-3 rounded-full">
                  {process.env.REACT_APP_CC_CTA_TEXT_MOBILE}
                </button>
              </div> : null}
            </div>
            {(renderMobileTP && vrgId) ? <SuccessBlock vrgId={vrgId}/> : null}
            <div className="flex flex-col  items-start justify-start bg-white  mt-4 w-full rounded-lg py-4 px-5 shadow-sm" style={{}}>
              <div className="flex flex-row items-start justify-start w-full  border-gray-100" style={{}}>
                <div className="flex flex-row items-start justify-start w-full border-b">
                  <div className={`flex flex-col items-start justify-start pb-4 lg:w-2/3`}>
                    {process.env.REACT_APP_CC_IS_EXPRESS_FORM === 'true'? null :<a href="https://www.carclarity.com.au/" target="_blank" rel="noopener noreferrer">
                      <img style={{ height: "29px", width: "104px" }} className="" alt="CarClarity Logo" src="https://widgets.carclarity.com.au/img/CarClarity.2d0241f0.svg" />
                    </a>}
                    <h2 className="text-xl text-gray-800 font-semibold mb-4 mt-4 ">{process.env.REACT_APP_CC_BULLETPOINT_CTA}</h2>
                    <ul className="cc-bullet-list" style={{}}>
                      <li className="cc-bullet-list-item">
                        <p className="text-gray-800 text-sm">{process.env.REACT_APP_CC_BULLETPOINT_1}</p>
                      </li>
                      <li className="cc-bullet-list-item">
                        <p className="text-gray-800 text-sm">{process.env.REACT_APP_CC_BULLETPOINT_2}</p>
                      </li>
                      <li className="cc-bullet-list-item">
                        <p className="text-gray-800 text-sm">{process.env.REACT_APP_CC_BULLETPOINT_3}</p>
                      </li>
                    </ul>
                  </div>
                  <div className={`flex flex-col banner-bg mt-12 pb-4 lg:w-1/3 ${getBannerClass()}`}>

                  </div>
                </div>
              </div>
              {renderMobileTP ? <TrustpilotMobile /> : <TrustpilotDesktop />}
            </div>
          </div>
            {/* <Header /> */}
            {/* {renderForm()} */}
            <ExpressForm isMobile={renderMobileTP} onsubmitHook= {onsubmitHook}/>
        </div>
      </div>
    </>
  )
}


export default Layout;